export default __webpack_public_path__ + "static/media/jionglin.7ebc55c0.jpeg";